const isWithinPastMinute = (timestampMillis: number): boolean => {
  const ONE_MIN_IN_MILLIS = 60000;
  const now = Date.now();

  return now - timestampMillis <= ONE_MIN_IN_MILLIS && timestampMillis <= now;
};

export const hasValidTooltipReferral = (sessionStorageKey: string): boolean => {
  try {
    const tooltipTimestamp = sessionStorage.getItem(sessionStorageKey);
    return Boolean(tooltipTimestamp && isWithinPastMinute(parseInt(tooltipTimestamp)));
  } catch (e) {
    console.error("could not access sessionStorage: ", e);
    return false;
  }
};
